import { useTheme as baseUseTheme } from 'react-jss';

const useTheme = () => baseUseTheme();

export default useTheme;